<template>
  <div class="mb-xl grid grid-cols-2 gap-sm">
    <ArendeProperty label="Kanal" data-testid="closed-arende-kanal">{{
      arende.kanal ? KanalTypeLabels[arende.kanal] : "-"
    }}</ArendeProperty>
    <ArendeProperty label="Kundgrupp" data-testid="closed-arende-kundgrupp">
      {{ arende.kundgrupp }}
    </ArendeProperty>
    <ArendeProperty
      label=" Överlämnad till"
      data-testid="closed-arende-overlamnad-till"
      >{{ arende.overlamnadTill }}</ArendeProperty
    >
    <ArendeProperty
      label="Namn - Kontaktuppgift i ärendet"
      data-testid="closed-arende-namn"
      >{{ arende.namn }}</ArendeProperty
    >
    <ArendeProperty
      label="E-postadress - Kontaktuppgift i ärendet"
      data-testid="closed-arende-epost"
      >{{ arende.email }}</ArendeProperty
    >
    <ArendeProperty
      label="Telefonnummer - Kontaktuppgift i ärendet"
      data-testid="closed-arende-telefonnummer"
      >{{ arende.telefonnummer }}</ArendeProperty
    >
    <ArendeProperty label="Ombud" data-testid="closed-arende-ombud">{{
      arende.ombud ? "Ja" : "Nej"
    }}</ArendeProperty>
  </div>
  <div>
    <ArendeProperty label="Kopiera länk till ärendet">
      <CopyToClipboard
        v-if="arende.id"
        text="Klicka här för att kopiera ärendelänk"
        :data="composeArbetsgivareArendetUrl(arende.id)"
      />
    </ArendeProperty>
  </div>
</template>

<script setup lang="ts">
import { KanalTypeLabels } from "@/common/constants";
import { composeArbetsgivareArendetUrl } from "@/common/utils/composeArbetsgivareArendetUrl";
import ArendeProperty from "@/components/arende-components/ArendeProperty.vue";
import CopyToClipboard from "@/components/ui/CopyToClipboard.vue";
import { Arbetsgivarearende } from "@/composables/KundserviceAppApiClient";

defineProps<{ arende: Arbetsgivarearende }>();
</script>
